import Tabs from 'components/tabs';
import Coordination from 'pages/master-data/coordination-user/coordination'
import User from 'pages/master-data/coordination-user/user'
import intl from 'react-intl-universal'

const CoordinationUser = () => {
  const coordinationUserContent = [
    {
      key: 1,
      label: intl.get('master-data.coordinationsAndUsers.coordinations.header.subtitle'),
      content: <Coordination />
    },
    {
      key: 2,
      label: intl.get('master-data.coordinationsAndUsers.users.header.title'),
      content: <User />
    }
  ];

    return (
      <Tabs 
        selected={2} 
        tabsContent={coordinationUserContent}
      />
    )
  }

export default CoordinationUser
